import { Col } from "react-grid-system";
import styled from "styled-components";
import { theme } from "../theme";

export const StyledUnitActions = styled(Col)`
	display: flex;
	flex-wrap: wrap;
	column-gap: 4.5rem;
	row-gap: 1.6rem;
	margin-top: 3rem;

	a {
		text-transform: uppercase;
		color: ${theme.color.green};
		display: inline-flex;
		align-items: center;
		font-size: 1.2rem;
		font-family: ${theme.font.secondary};
		font-weight: 500;
	}
`;
